const STORAGE_KEY = 'stationTemplates'

export const DEFAULT_TEMPLATES = [
  {
    name: 'AC 22kW Charger',
    description: 'Standard AC charger with 22kW Type2 connector',
    protocolVersion: 'ocpp1.6',
    vendor: 'Generic',
    model: 'AC-22',
    firmwareVersion: '1.0.0',
    connectors: [
      { id: 1, type: 'Type2', maxPower: 22000, status: 'Available' }
    ],
    supportedProfiles: ['Core', 'SmartCharging'],
    meterValuesConfig: {
      interval: 60,
      measurands: ['Energy.Active.Import.Register', 'Power.Active.Import'],
      alignedDataInterval: 900
    },
    simulation: {
      bootDelay: 0,
      heartbeatInterval: 300,
      statusNotificationOnChange: true,
      defaultIdTag: 'DEFAULT_TAG',
      energyDeliveryRate: 7000,
      randomizeMeterValues: true,
      meterValueVariance: 0.1,
      loadBalancing: true
    }
  },
  {
    name: 'DC 50kW Fast Charger',
    description: 'DC fast charger with CCS connector',
    protocolVersion: 'ocpp1.6',
    vendor: 'Generic',
    model: 'DC-50',
    firmwareVersion: '1.0.0',
    connectors: [
      { id: 1, type: 'CCS', maxPower: 50000, status: 'Available' }
    ],
    supportedProfiles: ['Core', 'SmartCharging'],
    meterValuesConfig: {
      interval: 30,
      measurands: ['Energy.Active.Import.Register', 'Power.Active.Import', 'Current.Import'],
      alignedDataInterval: 900
    },
    simulation: {
      bootDelay: 0,
      heartbeatInterval: 300,
      statusNotificationOnChange: true,
      defaultIdTag: 'DEFAULT_TAG',
      energyDeliveryRate: 45000,
      randomizeMeterValues: true,
      meterValueVariance: 0.05,
      loadBalancing: true
    }
  },
  {
    name: 'Dual Port AC Charger',
    description: 'Dual port AC charger with two Type2 connectors',
    protocolVersion: 'ocpp1.6',
    vendor: 'Generic',
    model: 'AC-DUAL-22',
    firmwareVersion: '1.0.0',
    connectors: [
      { id: 1, type: 'Type2', maxPower: 22000, status: 'Available' },
      { id: 2, type: 'Type2', maxPower: 22000, status: 'Available' }
    ],
    supportedProfiles: ['Core', 'SmartCharging', 'Reservation'],
    meterValuesConfig: {
      interval: 60,
      measurands: ['Energy.Active.Import.Register', 'Power.Active.Import'],
      alignedDataInterval: 900
    },
    simulation: {
      bootDelay: 0,
      heartbeatInterval: 300,
      statusNotificationOnChange: true,
      defaultIdTag: 'DEFAULT_TAG',
      energyDeliveryRate: 7000,
      randomizeMeterValues: true,
      meterValueVariance: 0.1,
      loadBalancing: true
    }
  }
]

function loadStoredTemplates() {
  const saved = localStorage.getItem(STORAGE_KEY)
  if (!saved) return []
  try {
    const parsed = JSON.parse(saved)
    return Array.isArray(parsed) ? parsed : []
  } catch (e) {
    console.error('Failed to load templates:', e)
    return []
  }
}

export function getStationTemplates() {
  const stored = loadStoredTemplates()
  return stored.length > 0 ? stored : [...DEFAULT_TEMPLATES]
}

export function findStationTemplate(name) {
  if (!name) return null
  const stored = loadStoredTemplates()
  return stored.find((template) => template.name === name)
    || DEFAULT_TEMPLATES.find((template) => template.name === name)
    || null
}
